import React from "react";
export const UserContext = React.createContext({
  state: {
    user: {},
    token: null
  },
  login: () => {},
  logout: () => {}
});